export class SignFrameColor {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignFrameColorsChoices = {
  WOOD: new SignFrameColor('Wit', 0),
  ALUMINIUM: new SignFrameColor('Zwart', 1),
};

export const SignFrameColorsChoiceArray = Object.values(SignFrameColorsChoices);
